import React, {useState, useEffect, useContext, useRef} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { history } from '../../_helpers';
import {DefaultColumnFilter, SelectColumnFilter} from '../Table/Table'
import {TableApp} from '../Table/Table'
import '../Nav/Nav.scss'
import ComRaboardDetail from './ComRaboardDetail';
import "./ComRaboard.scss"
import Select from 'react-select';

const columnsAtt = [
  //   {Header: 'Parent ID', accessor: 'parentUUID', Filter: DefaultColumnFilter,    filter: 'fuzzyText',},
  {id:'email', Header: 'E-mail',   accessor: 'email',   Filter: DefaultColumnFilter,    filter: 'fuzzyText',},
  {id:'position', Header: 'Position',      accessor: 'position', filter: 'includes',},
  {id:'path', Header: 'Path',      accessor: 'path', filter: 'includes',},
  {id:'status', Header: 'Status',      accessor: 'status', filter: 'includes',},
  {id:'created', Header: '',      accessor: 'created', Filter: SelectColumnFilter,     filter: 'includes',},
  {id:'updated', Header: 'Last',      accessor: 'updated', Filter: SelectColumnFilter,     filter: 'includes',},

]

const statusOptions = [
  { value: '지원완료', label: '지원완료'},
  { value: '서류합격', label: '서류합격'},
  { value: '면접요청', label: '면접요청'},
  { value: '최종합격', label: '최종합격'},
  { value: '불합격', label: '불합격'},
]

function ComRaboard(){
  const [state, actions] = useContext(UserContext);
  const [ra, setRa] = useState()
  const [single, setSingle] = useState() 
  const [applicants, setApplicants] = useState()
  const [docs, setDocus] = useState()

  const [selected, setSelected] = useState()

  const [isActive, setIsActive] = useState(false)
  
  const [status, setStatus] = useState()

  const dropdownRef = useRef(null);

  const [allApp, setAllApp] = useState()
  const [allDocu, setAllDocu] = useState()
  const [allRec, setAllRec] = useState()
  // const [allInterview, setAllInterview] = useState()
  const [allSuccess, setAllSuccess] = useState()
  const [allFailed, setAllFailed] = useState()
  const [allTimeout, setAllTimeout] = useState()

  const [jobobj, setJobobj] = useState([])
  const [joblist, setJoblist] = useState([])
  const [rabyjob, setRabyjob] = useState([])


  let user = JSON.parse(String(localStorage.getItem('user')))
  
  const header = {Authorization: `JWT ${user.token}`}

  // console.log(history.location.pathname.split('/')[3])

  useEffect(()=>{

    async function fetchRa(){
      fetch(state.awslink + "/api/ra/", {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        actions.setRa(json)

        let temp_allApp = 0;
        let temp_allDocu = 0;
        let temp_allRec = 0;
        let temp_allSuccess = 0;
        let temp_allFailed = 0;
        let temp_allTimeout = 0;
        // let temp_allInterview = 0;

        if(json){
          json.map((item)=>{
            temp_allApp = temp_allApp + item.applicant.length
            temp_allDocu = temp_allDocu + item.docu.length + item.docu_second.length
            temp_allRec = temp_allRec + item.recommended.length + item.recommended_second.length
            temp_allSuccess = temp_allSuccess + item.success.length + item.success_second.length
            temp_allFailed = temp_allFailed + item.failed.length + item.failed_second.length
            temp_allTimeout = temp_allTimeout + item.timeout.length + item.timeout_second.length
          })
        }

        setAllApp(temp_allApp)
        setAllDocu(temp_allDocu)
        setAllRec(temp_allRec)
        setAllSuccess(temp_allSuccess)
        setAllFailed(temp_allFailed)
        setAllTimeout(temp_allTimeout)
      }
      )
    }

    async function fetchRaHH(){
      fetch(state.awslink + "/api/rahh/", {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        // console.log(json)
        // console.log(json["ra"])

        actions.setRalist(json)
        let newobj = [];
        let newjob = [];
        let newjobobj = [];
        let newjobobjlist = [];
        
        
        if(json["ra"])
          if(json["ra"].length)
            {json["ra"].map((item, index)=>{
              newobj.push(item)
              newjobobj.push({id: item.id, color: 'ra'})
              if(item.job && item.job.length){
                item.job.map((subitem)=>{
                  if(!newjob.includes(subitem)) 
                  newjob.push(subitem)
                })
              }
            })}
        if(json["ra_shop_hh"])
          if(json["ra_shop_hh"].length)
            {json["ra_shop_hh"].map((item, index)=>{
              newobj.push(item)
              console.log(item)
              newjobobj.push({id: item.id, color: 'ra_shop_hh'})
              if(item.job && item.job.length){
                item.job.map((subitem)=>{
                  if(!newjob.includes(subitem)) 
                  newjob.push(subitem)
                })
              }
            })}
        if(json["ra_shop_7"])
          if(json["ra_shop_7"].length)
            {json["ra_shop_7"].map((item, index)=>{
              newobj.push(item)
              console.log(item)
              newjobobj.push({id: item.id, color: 'ra_shop_7'})
              if(item.job && item.job.length){
                item.job.map((subitem)=>{
                  if(!newjob.includes(subitem)) 
                  newjob.push(subitem)
                })
              }
            })}
        // console.log("newobj", newobj)
        // console.log("newjob", newjob)
        newjob.map((item, index)=>{
          let newrabyjob = [];
          newobj.map((subitem, index)=>{
            if(subitem.job.includes(item)){
              newrabyjob.push(subitem)
            }
          })
          // setRabyjob(oldAry=>[oldAry, newrabyjob])
          newjobobjlist.push(newrabyjob)
        })

        // console.log("newjobobjlist", newjobobjlist)
        setJobobj(newjobobj)
        setJoblist(newjob)
        setRabyjob(newjobobjlist)

        let temp_allApp = 0;
        let temp_allDocu = 0;
        let temp_allRec = 0;
        let temp_allSuccess = 0;
        let temp_allFailed = 0;
        let temp_allTimeout = 0;
        let temp_allInterview = 0;

        if(newobj){
          newobj.map((item)=>{
            // console.log(item.applicant)
            temp_allApp = temp_allApp + item.applicant.length
            temp_allDocu = temp_allDocu + item.docu.length + item.docu_second.length
            temp_allRec = temp_allRec + item.recommended.length + item.recommended_second.length
            // temp_allInterview = temp_allInterview + item.interview.length
            temp_allSuccess = temp_allSuccess + item.success.length + item.success_second.length
            temp_allFailed = temp_allFailed + item.failed.length + item.failed_second.length
            temp_allTimeout = temp_allTimeout + item.timeout.length + item.timeout_second.length
          })
        }

        actions.setRa(newobj)
        

        setAllApp(temp_allApp)
        setAllDocu(temp_allDocu)
        setAllRec(temp_allRec)
        setAllSuccess(temp_allSuccess)
        setAllFailed(temp_allFailed)
        setAllTimeout(temp_allTimeout)

      }
      )
    }

    if(localStorage.getItem("is_recruiter") === "true"){
      if(!state.ralist) fetchRa();
    }
    else if(localStorage.getItem("is_headhunter") === "true") {
      if(!state.ralist) fetchRaHH();
      else{
        let json = state.ralist
        let newobj = [];
        let newjob = [];
        let newjobobj = [];
        let newjobobjlist = [];
        
        console.log(json)
        
        if(json["ra"])
          if(json["ra"].length)
            {json["ra"].map((item, index)=>{
              newobj.push(item)
              newjobobj.push({id: item.id, color: 'ra'})
              if(item.job && item.job.length){
                item.job.map((subitem)=>{
                  if(!newjob.includes(subitem)) 
                  newjob.push(subitem)
                })
              }
            })}
        if(json["ra_shop_hh"])
          if(json["ra_shop_hh"].length)
            {json["ra_shop_hh"].map((item, index)=>{
              newobj.push(item)
              console.log(item)
              newjobobj.push({id: item.id, color: 'ra_shop_hh'})
              if(item.job && item.job.length){
                item.job.map((subitem)=>{
                  if(!newjob.includes(subitem)) 
                  newjob.push(subitem)
                })
              }
            })}
        if(json["ra_shop_7"])
          if(json["ra_shop_7"].length)
            {json["ra_shop_7"].map((item, index)=>{
              newobj.push(item)
              console.log(item)
              newjobobj.push({id: item.id, color: 'ra_shop_7'})
              if(item.job && item.job.length){
                item.job.map((subitem)=>{
                  if(!newjob.includes(subitem)) 
                  newjob.push(subitem)
                })
              }
            })}
        // console.log("newobj", newobj)
        // console.log("newjob", newjob)
        newjob.map((item, index)=>{
          let newrabyjob = [];
          newobj.map((subitem, index)=>{
            if(subitem.job.includes(item)){
              newrabyjob.push(subitem)
            }
          })
          // setRabyjob(oldAry=>[oldAry, newrabyjob])
          newjobobjlist.push(newrabyjob)
        })

        // console.log("newjobobjlist", newjobobjlist)
        setJobobj(newjobobj)
        setJoblist(newjob)
        setRabyjob(newjobobjlist)

        let temp_allApp = 0;
        let temp_allDocu = 0;
        let temp_allRec = 0;
        let temp_allSuccess = 0;
        let temp_allFailed = 0;
        let temp_allTimeout = 0;
        let temp_allInterview = 0;

        if(newobj){
          newobj.map((item)=>{
            // console.log(item.applicant)
            temp_allApp = temp_allApp + item.applicant.length
            temp_allDocu = temp_allDocu + item.docu.length + item.docu_second.length
            temp_allRec = temp_allRec + item.recommended.length + item.recommended_second.length
            // temp_allInterview = temp_allInterview + item.interview.length
            temp_allSuccess = temp_allSuccess + item.success.length + item.success_second.length
            temp_allFailed = temp_allFailed + item.failed.length + item.failed_second.length
            temp_allTimeout = temp_allTimeout + item.timeout.length + item.timeout_second.length
          })
        }
      }
    }
    
    
  }, [selected])
  
  // console.log(state.ra)
  // console.log(allApp, allDocu, allSuccess, allFailed, allTimeout)

  let current_id = history.location.pathname.split('/')[3]
  let current_status=history.location.pathname.split('/')[4]
  
  console.log("jobobj", jobobj)
  console.log("joblist", joblist)
  console.log("rabyjob", rabyjob)
  return(
    <>
    {state.width < state.breakpoint ? 
      null
    :
      <Wrapper>
        <MidWrapper>
        <LeftWrapper>
          <div className={"raboard-header"}>
              <h4>
                채용포지션
              </h4>
          </div>

          <div>
            {/* < Link to={"/recruiter/raboard/"} 
              className={!current_id ? "selected-a" : "nonselected-a"}>
              <div>전체</div>
            </Link> */}
            {joblist && joblist.length ? 
              joblist.map((jobitem, index)=>{
                let add_link = ''
                return(
                  <div>
                    <p>{jobitem}</p>
                    {rabyjob && rabyjob.length && rabyjob[index].map((item, index)=>{
                      if(item.status === "7%") add_link = "ra"
                      else add_link = "rahh"
                      let color = ''
                      let fontWeight = ''
                      let whichra = jobobj.filter(subitem=>subitem.id===item.id)[0]
                      
                      if(whichra.color === "ra") {color="red"; fontWeight="500"}
                      else if(whichra.color === "ra_shop_7") color="blue"
                      else if(whichra.color === "ra_shop_hh") color="black"
                      console.log(color)
                      // console.log(current_status, item.status)
                      
                      
                      return(
                        <Link 
                          onClick={()=>{actions.setSingleRa(item); console.log("SINGLERA")}} 
                          to={"/recruiter/raboard/" + item.id + '/' +  add_link } 
                          className={parseInt(current_id) === item.id 
                            && current_status === add_link ? "selected-a" : "nonselected-a"}
                          style={{color: color, fontWeight:fontWeight}}
                          >
                          <div>
                            {item.company? item.company.title: "(없음)"} 
                          </div>
                          {/* <div>{item.title}</div> */}
                          <div className={"allnum"}>
                            {
                              item.applicant.length +
                              item.cart.length +
                              item.cart_accept.length +
                              item.cart_accept_second.length +
                              item.cart_second.length +
                              item.cart_sent.length +
                              item.cart_sent_second.length +
                              item.docu.length +
                              item.docu_second.length +
                              item.failed.length +
                              item.failed_second.length +
                              item.recommended.length + 
                              item.recommended_accepted.length + 
                              item.recommended_accepted_second.length + 
                              item.recommended_second.length + 
                              item.recommended_sent.length + 
                              item.recommended_sent_second.length + 
                              item.success.length + 
                              item.success_second.length + 
                              item.timeout.length + 
                              item.timeout_second.length
                            }
                          </div>
                        </Link>
                      )
                    })}
                  </div>
                )
              })
            : 
            state.ra && localStorage.getItem("is_recruiter") === "true"&&
            state.ra.map((item, index)=>{
              let add_link = ''
              if(item.status === "7%") add_link = "ra"
              else add_link = "rahh"

              return(
                <Link 
                  onClick={()=>{actions.setSingleRa(item); console.log("SINGLERA")}} 
                  to={"/recruiter/raboard/" + item.id + '/' +  add_link } 
                  className={parseInt(current_id) === item.id ? "selected-a" : "nonselected-a"}
                  
                  >
                  
                  <div>{item.title}</div>
                  <div className={"allnum"}>
                    {
                      item.applicant.length +
                      item.cart.length +
                      item.cart_accept.length +
                      item.cart_accept_second.length +
                      item.cart_second.length +
                      item.cart_sent.length +
                      item.cart_sent_second.length +
                      item.docu.length +
                      item.docu_second.length +
                      item.failed.length +
                      item.failed_second.length +
                      item.recommended.length + 
                      item.recommended_accepted.length + 
                      item.recommended_accepted_second.length + 
                      item.recommended_second.length + 
                      item.recommended_sent.length + 
                      item.recommended_sent_second.length + 
                      item.success.length + 
                      item.success_second.length + 
                      item.timeout.length + 
                      item.timeout_second.length
                    }
                  </div>
                </Link>
              )
            })
            }
          </div>
        </LeftWrapper>
        {current_id?
        null:
        <RightWrapper>
          {/* <div>지원완료 - {allApp}</div>
          <div>서류합격 - {allDocu}</div>
          <div>전문가추천 - {allRec}</div>
          <div>최종합격 - {allSuccess}</div>
          <div>불합격 - {allFailed}</div>
          <div>기간만료 - {allTimeout}</div> */}

        </RightWrapper>
        }
        
        
        </MidWrapper>
      </Wrapper>   
      }
    </>
  )
}


const Wrapper = styled.div`
  display: flex;
  position: absolute;
  width: 100vw;
  height: calc(100vh - 45px);

  /* margin-top: 45px; */

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`
const MidWrapper = styled.div`
  display: flex;
  width: 90%;
  max-width: 1060px;
  height: 100%;
  justify-content: center;
  align-items: flex-start;
  position:absolute;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: row;
`

const LeftWrapper = styled.div`
    display: flex;
    min-width: 29%;
    max-width: 29%;
    margin-right: 71%;

    height: 90%;

    margin-top: 20px;

    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    background-color: rgba(255,255,255,1);

    z-index: 2;
    box-sizing: border-box;
    border: .5px solid rgba(0,0,0,0.2);
    border-radius: 5px;
    
    position: relative;

    .raboard-header{
      display: flex;
      align-items: center;

      width: 100%;
      height: 50px;
      max-height: 50px;
      min-height: 50px !important;

      padding: 15px;
      box-sizing: border-box;
      margin: 0;
      border-radius: 5px 5px 0px 0px;
      border-bottom: .5px solid rgba(0,0,0,0.2);
      position: sticky;
      top: 0;

      overflow-y: hidden;
      z-index: 2;

      background-color: rgba(255,255,255,1);
      /* -webkit-backdrop-filter: saturate(180%) blur(20px);
      backdrop-filter: saturate(180%) blur(20px); */
      h4{
        text-align: left;
        display: block;
        width: 100%;
        /* padding: 15px; */
        /* box-sizing: border-box; */
        margin: 0;
        /* padding-top: 20px; */
        /* padding-bottom: 20px; */
      }
    }

    >div:last-child{
      display: block;
      width: 100%;
      overflow-y: auto;
      position: relative;
      >div{
        
        >p{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          height: 50px;
          font-size: .95rem;
          color: black;
          text-align: left;
          box-sizing: border-box;
          padding: 5px;
          padding-left: 15px;
          margin: 0px;
        }
      }
      
      .selected-a, .nonselected-a{
        width: 100%;
        height: 50px;
        opacity: 1;
        cursor: pointer;

        text-decoration: none;
        color: black;

        text-align: left;

        box-sizing: border-box;
        padding: 5px;
        padding-left: 30px;
        display: flex;
        align-items: center;
        font-size: .95rem;
        transition: .2s;
        
        :hover{
          background-color: rgba(0,0,0,0.05);
        }

        .allnum{
          position: absolute;

          font-size: 0.8rem;
          right: 20px;
          
          text-align: center;
          width: 20px;
          height: 20px;
          border-radius: 3px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0,0,0,0.1);
          opacity: .8;
          color: black;
        }

      }
      .selected-a{
        background-color: rgba(0,0,0,0.1);
      }
      .nonselected-a{
        background-color: rgba(0,0,0,0);
      }
    }
    

`
const RightWrapper = styled.div`
    display: flex;
    min-width: 69%;
    max-width: 69%;
    /* margin-left: 31%; */
    min-height: 90%;
    position: absolute;
    margin-top: 20px;
    /* top: calc((100vh - 45px) * 0.05); */
    right: 0;
    height: auto;
    /* border: red solid; */
    background-color: rgba(255,255,255,1);

    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    z-index: 1;

    > span{
    /* background-color: red; */
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      margin-bottom: 30px;
      > div{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        /* flex-direction: column; */
        /* :last-child{
          position: absolute;
          left: 50%;
        } */
        
      }
    }
`

export default ComRaboard